module.exports = __webpack_public_path__ + "img/project02.1c5dbe81.png";